import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector, } from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';

import Lottie from 'lottie-react';
import { Col, Row, Table, Button } from 'react-bootstrap';
import celebration from 'pages/certifications/emet/wizard/lottie/celebration.json';
import { Card } from 'react-bootstrap';

import { certificationActions } from 'store/slices/certification/certificationSilce';

import { fetchEpstResultBySections } from 'api/certifications/epst/results';

import { handleApiError } from 'utils';

import styles from 'assets/scss/wizard/emetSuccess.module.scss';


const ResultEpst = () => {
    console.log("result epst");
    const token = useSelector(state => state.authentication.user?.token);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const location = useLocation();
    const certification = location.state; 

    const [epstScores, setEpstScores] = useState([]);

    useEffect(() => {
        if (token !== null && token !== undefined)
            loadEpstScores();
    }, [token]); 

    const loadEpstScores = async () => {
        try {
            const { data } = await fetchEpstResultBySections(certification.id, token);
            console.log(data);
            if(data?.status === 200) {
                setEpstScores(data.message);
            }
        } catch (error) {
            handleApiError(error);
        }
    };

    return (
        <>
            <Card className="mb-3 theme-wizard">
                <Card.Header className="border-bottom border-200">
                    <h6 className="mb-0">Resultados</h6>
                </Card.Header>
                <Card.Body>
                    <Row className={styles.centerItems}>
                        <Col className="text-center">
                            <div className="wizard-lottie-wrapper">
                                <div className="wizard-lottie mx-auto">
                                    <Lottie animationData={celebration} loop={true} />
                                </div>
                            </div>
                            <h4 className="mb-1">You have finished!</h4>
                            <p className="fs-0">You have successfully completed your test</p>
                            <Button
                                variant="primary"
                                size="lg"
                                onClick={() => {
                                    dispatch(certificationActions.resetCertification()); // Resetea el estado en Redux
                                    navigate('/'); // Redirige a la página principal
                                }}
                                className={`${styles.skipButton}`}>
                                Finished
                            </Button>
                        </Col>
                        <Col>
                        <Table
                                responsive
                                className={`table-lg`}
                                style={{
                                    fontSize: '0.9rem',
                                    marginTop: '5px',
                                    marginBottom: '5px',
                                }}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ padding: '15px' }}>Section</th>
                                        <th style={{ padding: '15px', textAlign: 'center' }}>Your score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {epstScores.map((score, index) => (
                                        <tr key={index} style={{ backgroundColor: "#f8f9fa" }}>
                                            <td style={{ padding: "15px" }}>{score.section_name}</td>
                                            <td style={{ textAlign: "center", padding: "15px" }}>
                                                {score.total_points === -1 ? (
                                                    <span className="text-muted fw-semibold">Pending</span>
                                                ) : (
                                                    <strong>{score.total_points}</strong>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                    <tr className="bg-white border-top border-3 ">
                                        <td style={{ padding: "15px", fontWeight: "bold" }}>Total</td>
                                        <td style={{ textAlign: "center", fontWeight: "bold", padding: "15px" }}>
                                            {epstScores
                                                .filter(score => score.total_points !== -1)
                                                .reduce((sum, score) => sum + score.total_points, 0)}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
};

export default ResultEpst;
